import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { planMutationKeys, planQueryKeys } from '../constants'
import { customQueryClient } from '../../config/query-client'

export const useCreatePlanFolderMutation = (options) => {
  const handleMutation = async ({ folderName, parentFolderId, projectId }) => {
    const config = {
      method: 'post',
      data: {
        name: folderName,
        parentId: parentFolderId
      }
    }

    const { data } = await api(
      `/api/v2/projects/${projectId}/planFolders`,
      config
    )
    return data
  }

  const invalidateRelatedQueries = () => {
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_TREE_QUERY]
    })
    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_TREE_INFINITY_QUERY]
    })

    customQueryClient.invalidateQueries({
      queryKey: [planQueryKeys.GET_PLANS_CHILDREN_TREE_QUERY]
    })
  }

  return useMutation({
    mutationFn: handleMutation,
    mutationKey: [planMutationKeys.CREATE_PLAN_FOLDER],
    retry: 0,
    ...options,
    onSuccess: (data, variables, context) => {
      invalidateRelatedQueries()

      options?.onSuccess?.(data, variables, context)
    },
    onError: (error, variables, context) => {
      options?.onError?.(error, variables, context)
    }
  })
}
